module.exports = __webpack_public_path__ + "cl.svg?cfda1dd135f276c2b8fad9fed88820a6";